import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class VisitorsConfigurationAbility extends Ability {
  @service declare authz: AuthzService;

  get canRead(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITORS_CONFIGURATION_READ);
  }

  get canManageEmployeeSignOutDisabled(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(
      Permission.VISITORS_VISITORS_CONFIGURATION_MANAGE_EMPLOYEE_SIGN_OUT_DISABLED,
    );
  }
}
